// A celebration is triggered only by a newly accepted code, never by cart re-renders.
let pecCodeApplied = Boolean(document.querySelector('[data-pec-code-success="LOLOGRASTE26"]'));
let pecCodeRequestedAt = 0;
let pecCodeUntil = 0;
let pecCodeTimer;
document.addEventListener('submit', event => {
  if (!event.target.matches('.cart-discount__form')) return;
  const value = event.target.querySelector('[name="discount"]')?.value.trim().toUpperCase();
  pecCodeRequestedAt = value === 'LOLOGRASTE26' ? Date.now() : 0;
}, true);
function syncPecCodeFeedback() {
  const banners = [...document.querySelectorAll('[data-pec-code-success="LOLOGRASTE26"]')];
  const applied = banners.length > 0;
  if (applied && !pecCodeApplied && pecCodeRequestedAt && Date.now() - pecCodeRequestedAt < 15000) {
    pecCodeUntil = Date.now() + 4200;
    pecCodeRequestedAt = 0;
    clearTimeout(pecCodeTimer);
    pecCodeTimer = setTimeout(() => { pecCodeUntil = 0; syncPecCodeFeedback(); }, 4200);
  }
  if (!applied) {
    pecCodeUntil = 0;
    clearTimeout(pecCodeTimer);
  }
  pecCodeApplied = applied;
  for (const banner of banners) {
    const show = Date.now() < pecCodeUntil;
    const display = show ? 'flex' : 'none';
    if (banner.style.display !== display) {
      banner.style.display = display;
      if (show) banner.style.setProperty('--pec-code-duration', Math.max(0, pecCodeUntil - Date.now()) + 'ms');
    }
  }
}


let pecGiftSaved;
let pecGiftWanted;
let pecGiftSaving;
function syncPecGiftBenefit() {
  const root = document.querySelector('[data-pec-surprise]');
  if (!root) return;
  pecGiftWanted = root.dataset.giftValue || '';
  if (pecGiftSaved === pecGiftWanted || pecGiftSaving) return;
  const url = root.dataset.giftUrl;
  pecGiftSaving = (async () => {
    while (pecGiftSaved !== pecGiftWanted) {
      const value = pecGiftWanted;
      const response = await fetch(url, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'Beneficio de compra':value}})});
      if (!response.ok) throw new Error('No se pudo guardar el beneficio del pedido.');
      pecGiftSaved = value;
    }
  })().catch(() => {}).finally(() => { pecGiftSaving = undefined; });
}
document.addEventListener('click', async event => {
  const checkout = event.target.closest('button[name="checkout"],input[name="checkout"],.cart__checkout-button');
  if (!checkout || !pecGiftSaving) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  await pecGiftSaving;
  checkout.click();
}, true);

function rankComplements(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const list = root.querySelector('.pec-extras__list');
  const gap = Number(root.dataset.gap);
  const cards = [...list.querySelectorAll('.pec-extra')];
  const candidates = cards.filter(card => card.dataset.extraAvailable === 'true');
  const related = candidates.filter(card => card.dataset.extraRelated === 'true');
  const chosen = related.slice(0,2);
  const remaining = candidates.filter(card => !chosen.includes(card));
  const qualifying = gap > 0 ? remaining.filter(card => Number(card.dataset.extraPrice) >= gap).sort((a,b)=>Number(a.dataset.extraPrice)-Number(b.dataset.extraPrice))[0] : null;
  const economical = remaining.sort((a,b)=>Number(a.dataset.extraPrice)-Number(b.dataset.extraPrice));
  if (qualifying || economical[0]) chosen.push(qualifying || economical[0]);
  for (const card of economical) {
    if (chosen.length >= 3) break;
    if (!chosen.includes(card)) chosen.push(card);
  }
  cards.forEach(card => { card.hidden = !chosen.includes(card); });
  chosen.forEach(card => list.append(card));
  root.hidden = chosen.length === 0;
}
function positionLook(windowEl, image, design) {
  windowEl.style.width = '100%';
  windowEl.style.height = '100%';
  windowEl.style.aspectRatio = '1';
  windowEl.style.clipPath = 'none';
  image.style.width = '100%';
  image.style.height = '100%';
  image.style.left = '';
  image.style.top = '';
  image.removeAttribute('srcset');
  image.removeAttribute('sizes');
  image.removeAttribute('width');
  image.removeAttribute('height');
  image.src = design.src;
  image.alt = design.name;
}
function initializeLook(root) {
  if (root.dataset.lookReady) return;
  root.dataset.lookReady = 'true';
  const config = JSON.parse(root.querySelector('[data-look-config]').textContent)[root.dataset.handle];
  if (!config) return;
  const choices = root.querySelector('[data-look-choices]');
  const name = root.querySelector('[data-look-name]');
  const status = root.querySelector('[data-look-status]');
  const image = root.querySelector('[data-look-image]');
  const windowEl = root.querySelector('[data-look-window]');
  function show(design, previewOnly=false) {
    positionLook(windowEl,image,design);
    name.textContent=design.name;
    status.textContent=previewOnly ? root.dataset.unavailableText : '';
    choices.querySelectorAll('button').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.lookVariant===design.id)));
  }
  config.variants.forEach(design=>{
    const button=document.createElement('button');
    button.type='button';button.dataset.lookVariant=design.id;button.setAttribute('aria-label',root.dataset.viewText+': '+design.name);
    const thumbnail=document.createElement('div');thumbnail.className='pec-look__thumb';
    const window=document.createElement('div');window.className='pec-look__window';
    const img=document.createElement('img');img.loading='lazy';img.alt='';window.append(img);thumbnail.append(window);positionLook(window,img,design);
    const label=document.createElement('span');label.textContent=design.name;button.append(thumbnail,label);
    button.addEventListener('click',()=>{
      const section=root.closest('.shopify-section');
      const input=[...section.querySelectorAll('variant-picker input[type=radio]')].find(input=>input.dataset.variantId===design.id);
      if(input&&!input.disabled){if(!input.checked)input.click();show(design);}else{show(design,true);}
    });
    choices.append(button);
  });
  root.showLook=id=>{const design=config.variants.find(design=>design.id===String(id));if(design)show(design);};
  root.showLook(root.dataset.variant || config.variants[0].id);
}
function setupPurchase() {
  syncPecCodeFeedback();
  syncPecGiftBenefit();
  document.querySelectorAll('[data-pec-extras]').forEach(rankComplements);
  document.querySelectorAll('[data-pec-look]').forEach(initializeLook);
}
document.addEventListener('change',event=>{
  const extra=event.target.closest('[data-pec-extra-variant]');
  if(extra){
    const selected=extra.selectedOptions[0], form=extra.closest('product-form-component'),card=extra.closest('.pec-extra');
    form.querySelector('input[name=id]').value=extra.value;
    card.querySelector('[data-extra-price-label]').textContent=selected.dataset.priceLabel;
    const image=card.querySelector('img');
    if(image&&selected.dataset.image){image.removeAttribute('srcset');image.src=selected.dataset.image;image.alt=selected.dataset.imageAlt;}
  }
  const picker=event.target.closest('variant-picker');
  if(picker){
    const selected=event.target.selectedOptions?.[0]||event.target;
    const gallery=picker.closest('.shopify-section')?.querySelector('[data-pec-look]');
    gallery?.showLook?.(selected.dataset.variantId);
  }
});
let purchaseFrame;
new MutationObserver(()=>{cancelAnimationFrame(purchaseFrame);purchaseFrame=requestAnimationFrame(setupPurchase);}).observe(document.documentElement,{childList:true,subtree:true});
document.addEventListener('shopify:section:load',setupPurchase);
setupPurchase();


function updatePecCombo(root) {
  const money = cents => new Intl.NumberFormat('es-MX', {style:'currency',currency:'MXN'}).format(cents/100);
  const mainForm = root.closest('.shopify-section')?.querySelector(`product-form-component[data-product-id="${root.dataset.productId}"] form`);
  const quantity = Math.max(1, Number(mainForm?.querySelector('[name="quantity"]')?.value || 1));
  let total = Number(root.dataset.price) * quantity;
  let selectedCount = 0;
  root.querySelectorAll('.pec-combo__item').forEach(card => {
    const option = card.querySelector('select').selectedOptions[0];
    if (!option) return;
    card.querySelector('[data-combo-price]').textContent = money(Number(option.dataset.price));
    const image = card.querySelector('img');
    if (image && option.dataset.image && image.getAttribute('src') !== option.dataset.image) {
      image.removeAttribute('srcset');
      image.src = option.dataset.image;
    }
    if (card.querySelector('[data-combo-check]').checked) {
      total += Number(option.dataset.price);
      selectedCount++;
    }
  });
  root.querySelector('[data-combo-total]').textContent = money(total);
  root.querySelector('[data-combo-add]').disabled = !selectedCount || root.dataset.busy === 'true';
}
document.addEventListener('change', event => {
  const root = event.target.closest('[data-pec-combo]');
  if (root) updatePecCombo(root);
  else if (event.target.matches('[name="quantity"]')) event.target.closest('.shopify-section')?.querySelectorAll('[data-pec-combo]').forEach(updatePecCombo);
});
document.addEventListener('click', async event => {
  const button = event.target.closest('[data-combo-add]');
  if (!button || button.disabled) return;
  const root = button.closest('[data-pec-combo]');
  const form = root.closest('.shopify-section')?.querySelector(`product-form-component[data-product-id="${root.dataset.productId}"] form`);
  const status = root.querySelector('[data-combo-status]');
  const variant = form?.querySelector('input[name="id"]');
  if (!variant?.value) { status.textContent = button.dataset.error; return; }
  const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value || 1));
  const items = [{id:variant.value, quantity}];
  root.querySelectorAll('.pec-combo__item').forEach(card => {
    if (card.querySelector('[data-combo-check]').checked) items.push({id:card.querySelector('select').value,quantity:1});
  });
  if (items.length < 2) return;
  root.dataset.busy = 'true';
  button.disabled = true;
  status.textContent = button.dataset.busy;
  try {
    const response = await fetch(root.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || button.dataset.error);
    window.location.assign(root.dataset.cartUrl);
  } catch (error) {
    status.textContent = error.message || button.dataset.error;
    delete root.dataset.busy;
    updatePecCombo(root);
  }
});
